// Calendar icon matching EBX UI component library design
function CalendarIcon({
  size = 16,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill={color}
        d="M6.313 3.5h3.375v-.937a.562.562 0 1 1 1.124 0V3.5h.938a1.5 1.5 0 0 1 1.5 1.5v7.5c0 .827-.673 1.5-1.5 1.5h-7.5a1.5 1.5 0 0 1-1.5-1.5V5a1.5 1.5 0 0 1 1.5-1.5h.938v-.937a.562.562 0 1 1 1.125 0zm-2.438 9c0 .206.168.375.375.375h7.5a.376.376 0 0 0 .375-.375v-6h-8.25z"
      />
    </svg>
  );
}

export default CalendarIcon;
